import React from 'react'
import styled from 'styled-components'
import media from 'css-in-js-media'

import { Variables } from '../styles/Variables'
import Container from './Container'
import Section from './Section'
import { BodyCopy } from './Typography'

const CopySection = styled(Section)`
    margin: 0;
    padding-bottom: 97px;
    background-color: ${Variables.color.white};

    ${media('<desktop')} {
        padding-bottom: 40px;
    }

    ${BodyCopy} {        
        font-family: ${Variables.font.body};
        color: ${Variables.color.pazola};

        p {            
            font-style: normal;            
            font-size: 18px;
            line-height: 22px;    
            ${media('<desktop')} {
                font-size: 16px;
                line-height: 20px;
            }        
        }

        strong {
            font-weight: 600;
        }

        h5 {
            font-family: ${Variables.font.title};
            font-style: normal;
            font-weight: 300;
            font-size: 24px;
            line-height: 30px;
            ${media('<desktop')} {
                font-size: 16px;
                line-height: 20px;
            } 
        }

        img {
            display: block;
            margin: 0 auto;            
        }
    }

    ${Container} {
        width: 874px;
        margin: 0 auto;
        padding-left: 20px;
        padding-right: 20px;

        ${media('<desktop')} {
            width: 100%;
            padding-left: 20px;
            padding-right: 20px;
        }
    }

    ${media('<desktop')} {
        padding-left: 0;
    }
`

const Copy: React.FC<{
    data: object
}> = ({ data }) => {
    return (
        <>
            <CopySection>
                <Container>
                    <BodyCopy
                        dangerouslySetInnerHTML={{
                            __html: data.copy.childMarkdownRemark.html,
                        }}
                    />
                </Container>
            </CopySection>
        </>
    )
}

export default Copy
